import React from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import * as commonActions from "../../../store/common/actions";
import StorefrontIcon from "@material-ui/icons/Storefront";
import SearchIcon from "@material-ui/icons/Search";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";
import EnglishToPersian from "../../UI/helpers/EnglishToPersian";

const BottomBar = (props) => {
  const styles = makeStyles((theme) => ({
    root: {
      borderRadius: "45px",
      position: "fixed",
      zIndex: 10,
      bottom: "0",
      width: "100%",
      height: 68,
      backgroundColor: "rgba(224, 224, 224, .4)",
    },
    container: {
      display: "flex",
      backdropFilter: "blur(6px)",
      alignItems: "center",
      textAlign: "center",
      justifyContent: "space-around",
      height: "100%",
      position: "relative",
      "& .active": {
        color: theme.palette.primary.main,
      },
    },
    links: { position: "relative" },
    badge: {
      position: "absolute",
      top: -6,
      right: -6,
      backgroundColor: theme.palette.primary.main,
      borderRadius: "100%",
      fontSize: 11,
      width: 18,
      height: 18,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: "#FFF",
      textAlign: "center",
    },
  }));
  const classes = styles();
  return props.width < 600 ? (
    <div className={classes.root}>
      <div className={classes.container}>
        {props.store_id ? (
          <React.Fragment>
            <div>
              <NavLink
                exact
                to={"/store/" + props.store_name + "/" + props.store_id}
              >
                <div className={classes.links}>
                  <StorefrontIcon />
                  <div style={{ fontSize: 10, fontWeight: "lighter" }}>
                    فروشگاه
                  </div>
                </div>
              </NavLink>
            </div>
            <div>
              <NavLink
                to={
                  "/store/" +
                  props.store_name +
                  "/" +
                  props.store_id +
                  "/categories"
                }
              >
                <div className={classes.links}>
                  <SearchIcon />
                  <div style={{ fontSize: 10, fontWeight: "lighter" }}>
                    دسته بندی
                  </div>
                </div>
              </NavLink>
            </div>
          </React.Fragment>
        ) : null}
        {props.is_auth ? (
          <>
            <div>
              <NavLink to={"/account"}>
                <div className={classes.links}>
                  {props.user && props.user.MessageUnreadCount ? (
                    <div className={classes.badge}>
                      {props.user &&
                        EnglishToPersian(props.user.MessageUnreadCount)}
                    </div>
                  ) : null}
                  <PermIdentityIcon />
                </div>
                <div style={{ fontSize: 10, fontWeight: "lighter" }}>
                  پروفایل
                </div>
              </NavLink>
            </div>
            {props.store_id && (
              <div onClick={() => props.toggleCart(true)}>
                <div className={classes.links}>
                  <ShoppingCartIcon />
                  <div style={{ fontSize: 10, fontWeight: "lighter" }}>
                    سبد خرید
                  </div>
                </div>
              </div>
            )}
          </>
        ) : null}
      </div>
    </div>
  ) : null;
};

const setStore = (dispatch) => ({
  toggleCart: (res) => dispatch(commonActions.toggleCart(res)),
});

const getStore = (state) => ({
  width: state.common.size.width,
  user: state.auth.user,
  is_auth: state.auth.is_auth,
});

export default connect(getStore, setStore)(BottomBar);
